// import React, { useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { getUserPriviliges, userModeChange, updateUserIsInstructor } from 'Store/UserInfo/Actions';
// import displayGlobalMessage from 'Utils/DisplayGlobalMessage';
// import { Navbar, Nav, Container, Image, Dropdown, NavLink } from 'react-bootstrap';
// import { Link, useLocation } from 'react-router-dom';
// import ProfileButton from './ProfileButton';
// import LoginButton from 'Screens_old/Layout/Common/Components/LoginButton';

// const NavigationBar = () => {
//   const userInfo = useSelector(state => state.userInfo);
//   const isAuthenticated = userInfo.token !== null;
//   const dispatch = useDispatch();
//   const location = useLocation();

//   useEffect(() => {
//     async function getPrivileges() {
//       let is_instructor = await getUserPriviliges();
//       dispatch(updateUserIsInstructor(is_instructor?.is_instructor));
//     }

//     if (isAuthenticated && !userInfo.is_instructor) getPrivileges();
//   }, [isAuthenticated]);

//   const handleModeChange = modeToChange => {
//     if (modeToChange === userInfo.mode) return;
//     if (modeToChange === 'S' || userInfo.is_instructor === true) {
//       dispatch(userModeChange(modeToChange));
//     } else {
//       displayGlobalMessage('You are not an instructor!', 'error');
//     }
//   };

//   const isActiveNavLink = (to) => {
//     return location.pathname === to;
//   };

//   return (
//     <div className='sticky-top'>
//       <Navbar className='p-0 bg-white' expand='lg' variant='light'>
//         <Container fluid className='px-2'>
//           <Navbar.Brand as={Link} to='/'>
//             <Image
//               src='/images/bodhitree_icon.png'
//               alt='Bodhitree Logo'
//             />
//           </Navbar.Brand>

//           <Navbar.Toggle aria-controls='responsive-navbar-nav' />
//           <Navbar.Collapse id='responsive-navbar-nav' className='justify-content-end align-items-center'> {/* Changed justify-content-between to justify-content-end */}
//             {isAuthenticated ? (
//               <>
//                 {userInfo.is_instructor && (
//                   <Nav>
//                     <div className='my-auto px-2 mb-0  text-secondary'>Mode:</div>
//                     <Dropdown onSelect={handleModeChange}>
//                       <Dropdown.Toggle>
//                         {userInfo.mode === 'I' ? 'Instructor' : 'Student'}
//                       </Dropdown.Toggle>
//                       <Dropdown.Menu>
//                         <Dropdown.Item eventKey='I'>Instructor</Dropdown.Item>
//                         <Dropdown.Item eventKey='S'>Student</Dropdown.Item>
//                       </Dropdown.Menu>
//                     </Dropdown>
//                   </Nav>
//                 )}
//                 <NavLink
//                   as={Link}
//                   to='/courseware/courseslist'
//                   className={`nav-link ${isActiveNavLink('/courseware/courseslist') ? 'text-primary' : 'text-secondary'}`}
//                 >
//                   My Courses
//                 </NavLink>
//                 <NavLink
//                   as={Link}
//                   to='/courseware'
//                   className={`nav-link ${isActiveNavLink('/courseware') ? 'text-primary' : 'text-secondary'}`}
//                 >
//                   Explore
//                 </NavLink>
//                 <ProfileButton email={userInfo.email} username={userInfo.username} />
//               </>
//             ) : (
//               <Nav>
//                 <LoginButton />
//               </Nav>
//             )}
//             {/* <Nav>
//                 <NavLink
//                   as='a'
//                   href={feedBackFormURL}
//                   target='_blank'
//                   className='nav-link text-secondary'
//                 >
//                   Feedback
//                 </NavLink>
//               </Nav> */}
//           </Navbar.Collapse>
//         </Container>
//       </Navbar>
//       <hr className='border border-secondary border-1 opacity-75 p-0 m-0' />
//     </div>
//   );
// };

// export default NavigationBar;

import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUserPriviliges, userModeChange, updateUserIsInstructor } from 'Store/UserInfo/Actions';
import displayGlobalMessage from 'Utils/DisplayGlobalMessage';
import { Navbar, Nav, Container, Image, Dropdown, NavLink, Button, Alert } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import ProfileButton from './ProfileButton';
import Chip from '@mui/material/Chip';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { logout } from 'Store/UserInfo/Actions'
import LoginButton from 'Screens_old/Layout/Common/Components/LoginButton';
import { enableRoleDisplayInNavbar } from 'Constants';

const NavigationBar = () => {
  const userInfo = useSelector(state => state.userInfo);
  const userCourseRole = useSelector(state => state.userCourseRole);
  const isAuthenticated = userInfo.token !== null;
  const dispatch = useDispatch();
  const location = useLocation();
  const [showDrawer, setShowDrawer] = useState(false);

  useEffect(() => {
    async function getPrivileges() {
      let is_instructor = await getUserPriviliges();
      dispatch(updateUserIsInstructor(is_instructor?.is_instructor));
    }

    if (isAuthenticated && !userInfo.is_instructor) getPrivileges();
  }, [isAuthenticated]);

  useEffect(() => {
    // Lock body scroll when drawer is open
    if (showDrawer) {
      document.body.classList.add('overflow-hidden');
    } else {
      document.body.classList.remove('overflow-hidden');
    }

    return () => {
      document.body.classList.remove('overflow-hidden');
    };
  }, [showDrawer]);

  const handleModeChange = modeToChange => {
    if (modeToChange === userInfo.mode) return;
    if (modeToChange === 'S' || userInfo.is_instructor === true) {
      dispatch(userModeChange(modeToChange));
    } else {
      displayGlobalMessage('You are not an instructor!', 'error');
    }
  };

  const isActiveNavLink = (to) => {
    return location.pathname === to;
  };

  const toggleDrawer = () => {
    setShowDrawer(!showDrawer);
  };

  const closeDrawer = () => {
    setShowDrawer(false);
  };

  // Custom ProfileButton for the mobile drawer
  const MobileProfileButton = ({ email, username }) => {
    return (
      <Dropdown as={Nav}>
        <Dropdown.Toggle
          className='px-2'
          as={Chip}
          icon={<AccountCircleIcon />}
          label={username ? username : email}
          variant='outlined'
        />
        <Dropdown.Menu>
          <Dropdown.Item
            as={Link}
            to='/profile'
            onClick={closeDrawer}
          >
            Profile
          </Dropdown.Item>
          <Dropdown.Item
            as={Link}
            to='/'
            onClick={async () => {
              await dispatch(logout());
              closeDrawer();
            }}
          >
            Logout
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  return (
    <div className='sticky-top'>
      <Navbar className='p-0 bg-white' variant='light'>
        <Container fluid className='px-2'>
          <Navbar.Brand as={Link} to='/'>
            <Image
              src='/images/bodhitree_icon.png'
              alt='Bodhitree Logo'
            />
          </Navbar.Brand>

          {/* Desktop navigation - visible on lg screens and up */}
          <div className="d-none d-lg-flex align-items-center ml-auto">
            {isAuthenticated ? (
              <>
              {
                enableRoleDisplayInNavbar ? (
                  <>
                    {
                    userCourseRole === 'STUDENT' && (
                      <Alert className='my-auto p-2 mx-2' variant='success'>STUDENT</Alert>
                    )
                    }
                    {
                      userCourseRole === 'INSTRUCTOR' && (
                        <Alert className='my-auto p-2 mx-2' variant='danger'>INSTRUCTOR</Alert>
                      )
                    }
                    {
                      userCourseRole === 'STA' && (
                        <Alert className='my-auto p-2 mx-2' variant='info'>STA</Alert>
                      )
                    }
                    {
                      userCourseRole === 'JTA' && (
                        <Alert className='my-auto p-2 mx-2' variant='warning'>JTA</Alert>
                      )
                    }
                  </>
                ) : null
              }
                {userInfo.is_instructor && (
                  <Nav>
                    <div className='my-auto px-2 mb-0 text-secondary'>Mode:</div>
                    <Dropdown onSelect={handleModeChange}>
                      <Dropdown.Toggle>
                        {userInfo.mode === 'I' ? 'Instructor' : 'Student'}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item eventKey='I'>Instructor</Dropdown.Item>
                        <Dropdown.Item eventKey='S'>Student</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </Nav>
                )}
                <NavLink
                  as={Link}
                  to='/courseware/courseslist'
                  className={`nav-link ${isActiveNavLink('/courseware/courseslist') ? 'text-primary' : 'text-secondary'}`}
                >
                  My Courses
                </NavLink>
                <NavLink
                  as={Link}
                  to='/courseware'
                  className={`nav-link ${isActiveNavLink('/courseware') ? 'text-primary' : 'text-secondary'}`}
                >
                  Explore
                </NavLink>
                <ProfileButton email={userInfo.email} username={userInfo.username} />
              </>
            ) : (
              <Nav>
                <LoginButton />
              </Nav>
            )}
          </div>

          {/* Mobile toggle button */}
          <Button
            variant="light"
            className="d-lg-none ml-auto"
            onClick={toggleDrawer}
          >
            <span className="navbar-toggler-icon"></span>
          </Button>
        </Container>
      </Navbar>
      <hr className='border border-secondary border-1 opacity-50 p-0 m-0' />

      {/* Mobile drawer backdrop */}
      <div
        className={`position-fixed d-lg-none ${showDrawer ? 'd-block' : 'd-none'}`}
        style={{
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0,0,0,0.5)',
          zIndex: 1030
        }}
        onClick={(e) => {
          // Only close drawer if clicking on the backdrop directly, not on any children
          if (e.target === e.currentTarget) {
            closeDrawer();
          }
        }}
      />

      {/* Mobile drawer */}
      <div
        className="position-fixed bg-white d-lg-none h-100 overflow-auto"
        style={{
          top: 0,
          left: showDrawer ? '0' : '-280px',
          width: '280px',
          zIndex: 1040,
          transition: 'left 0.3s ease'
        }}
      >
        <div className="p-3 border-bottom">
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="m-0">Menu</h5>
            <Button variant="light" className="p-0" onClick={closeDrawer}>×</Button>
          </div>
        </div>
        <div className="p-3">
          <Nav className="flex-column">
            {isAuthenticated ? (
              <>
                {userInfo.is_instructor && userInfo.mode !== 'S' && (
                  <div className="mb-3">
                    <div className='mb-2 text-secondary'>Mode:</div>
                    <Dropdown onSelect={handleModeChange}>
                      <Dropdown.Toggle className="w-100">
                        {userInfo.mode === 'I' ? 'Instructor' : 'Student'}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item eventKey='I'>Instructor</Dropdown.Item>
                        <Dropdown.Item eventKey='S'>Student</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                )}
                <NavLink
                  as={Link}
                  to='/courseware/courseslist'
                  className={`nav-link px-0 ${isActiveNavLink('/courseware/courseslist') ? 'text-primary' : 'text-secondary'}`}
                  onClick={closeDrawer}
                >
                  My Courses
                </NavLink>
                <NavLink
                  as={Link}
                  to='/courseware'
                  className={`nav-link px-0 ${isActiveNavLink('/courseware') ? 'text-primary' : 'text-secondary'}`}
                  onClick={closeDrawer}
                >
                  Explore
                </NavLink>
                <div className="mt-3">
                  {/* <ProfileButton email={userInfo.email} username={userInfo.username} /> */}
                  <MobileProfileButton email={userInfo.email} username={userInfo.username} />
                </div>
              </>
            ) : (
              <Nav.Item>
                <LoginButton />
              </Nav.Item>
            )}
          </Nav>
        </div>
      </div>
    </div>
  );
};

export default NavigationBar;